import BillingCancelMembershipPage from './BillingCancelMembership.page';

export default BillingCancelMembershipPage;
